import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { History, ChevronDown } from 'lucide-react';
import Program from './Program';
import { campPrograms2026 } from '../data/programData2026';

const PreviousYear: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="previous-year" className="py-14 bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <motion.button
          type="button"
          onClick={() => setOpen((v) => !v)}
          whileHover={{ y: -1 }}
          whileTap={{ scale: 0.99 }}
          className="mx-auto flex items-center gap-3 bg-white border border-gray-200 hover:border-gray-300 rounded-2xl px-5 py-4 shadow-sm hover:shadow-md transition-all max-w-2xl w-full"
          aria-expanded={open}
          aria-controls="previous-year-content"
        >
          <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0">
            <History className="w-5 h-5 text-gray-500" />
          </div>
          <div className="text-left flex-1 min-w-0">
            <p className="text-xs uppercase tracking-widest text-gray-400 font-semibold">Arhīvs</p>
            <p className="font-semibold text-gray-700 truncate">Apskatīt pagājušā gada programmu (2026)</p>
          </div>
          <motion.div animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.25 }}>
            <ChevronDown className="w-5 h-5 text-gray-400" />
          </motion.div>
        </motion.button>

        <AnimatePresence initial={false}>
          {open && (
            <motion.div
              id="previous-year-content"
              key="content"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.35, ease: 'easeOut' }}
              className="overflow-hidden"
            >
              <div className="mt-6 rounded-3xl bg-white shadow-inner border border-gray-100">
                <div className="px-6 pt-6">
                  <p className="inline-block text-xs uppercase tracking-widest font-semibold text-gray-500 bg-gray-100 rounded-full px-3 py-1">
                    Pagājušais gads · 2026
                  </p>
                  <p className="mt-2 text-sm text-gray-500">
                    Šī ir 2026. gada nometnes programma, lai redzētu, kas SuperWeek nedēļā notiek. 2027. gada programma tiks publicēta tuvāk datumiem.
                  </p>
                </div>
                <Program
                  programs={campPrograms2026}
                  closingNote={
                    <>
                      Vienā no vakariem plānots ugunskurs. Sestdien, <strong>11. jūlijā</strong>, visi ir
                      laipni aicināti uz noslēguma pasākumu teltī plkst. <strong>11:00</strong> un kopīgo
                      bildi plkst. <strong>13:00</strong>.
                    </>
                  }
                />
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default PreviousYear;
